// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m5-0";
export var assigneeDetails = "_m5-1";
export var assigneeInfo = "_m5-2";
export var dropdownContainer = "_m5-4";
export var dropdownImage = "_m5-5";
export var editAssigneeInfo = "_m5-3";
export var editAssigneeModalContainer = "_m5-6";
export var hidden = "_m5-8";
export var input = "_m5-7";